define(['exports', 'react', 'prop-types', '../../assets/search.svg', './Field'], function (exports, _react, _propTypes, _search, _Field) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _search2 = _interopRequireDefault(_search);

  var _Field2 = _interopRequireDefault(_Field);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SearchTextField = function (_Component) {
    _inherits(SearchTextField, _Component);

    function SearchTextField(props) {
      _classCallCheck(this, SearchTextField);

      var _this = _possibleConstructorReturn(this, (SearchTextField.__proto__ || Object.getPrototypeOf(SearchTextField)).call(this, props));

      _this.state = { showClearIcon: props.searchText && props.searchText.length > 0 };
      return _this;
    }

    _createClass(SearchTextField, [{
      key: 'handleChange',
      value: function handleChange(searchText) {
        this.props.onChange && this.props.onChange(searchText);
      }
    }, {
      key: 'handleEnterKeyDown',
      value: function handleEnterKeyDown() {
        var query = this.props.searchText.trim();

        if (this.props.onEnterKeyDown && query.length > 0) {
          this.props.onEnterKeyDown(query, false, true);
        } else if (this.props.clearSearch) {
          this.props.defaultState();
        }
      }
    }, {
      key: 'handleClearSearch',
      value: function handleClearSearch() {
        this.props.clearSearch && this.props.clearSearch();
        this.setState({ showClearIcon: false });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            error = _props.error,
            handleChange = _props.handleChange;


        var searchIconStyle = {
          top: '1rem',
          right: '2.2rem'
        };

        return _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'col sm-col-11 lg-col-11 z1 pr1', style: { border: 'node' } },
            _react2.default.createElement(_Field2.default, _extends({}, this.props, {
              backgroundColor: '#F5F5F5',
              value: this.props.searchText || '',
              placeholder: this.props.placeholder,
              inputType: 'text',
              onChange: handleChange
              // onEnter={() => this.handleEnter()}
              , error: this.state.showErrors && error }))
          ),
          _react2.default.createElement(
            'div',
            {
              style: searchIconStyle,
              className: 'relative right-align col sm-col-1 lg-col-1 z2' },
            _react2.default.createElement(_search2.default, { className: 'svg-icon svg-black' })
          )
        );
      }
    }]);

    return SearchTextField;
  }(_react.Component);

  exports.default = SearchTextField;


  SearchTextField.propTypes = {
    onChange: _propTypes2.default.func,
    hintText: _propTypes2.default.string.isRequired,
    width: _propTypes2.default.string
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/common/SearchTextField.js
// module id = 1151
// module chunks = 0